import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../store/slices/modal/modalSlice";
import { HiOutlineExclamationCircle } from "react-icons/hi2";
import { useTranslation } from "react-i18next";
import "./GlobalModel.css"

export function GlobalModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { show, title, message, type, onConfirm } = useSelector(
    (state) => state.modal
  );

  const handleClose = () => dispatch(hideModal());

  const handleConfirm = () => {
    onConfirm?.();
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="sm"
      backdrop="static"
      dialogClassName="custom-confirm-modal"
    >
      <Modal.Body className="text-center px-4 py-4">
        {/* Icon */}
        {type === "confirm" && (
          <div className="icon-wrapper mb-3">
            <HiOutlineExclamationCircle size={28} />
          </div>
        )}

        {/* Title */}
        <h5 className="fw-bold mb-2">{title}</h5>

        {/* Message */}
        <p className="text-muted small mb-0">{message}</p>
        <p className="text-muted small mb-4">{t('validation.actionCantDone')}</p>

        {/* Actions */}
        <div className="d-flex justify-content-center gap-3">
          {type === "confirm" && (
            <Button
              variant="light"
              className="px-4"
              onClick={handleClose}
            >
              {t("common.cancel")}
            </Button>
          )}

          <Button
            variant="danger"
            className="px-4"
            onClick={handleConfirm}
          >
            {type === "confirm" ? t("common.delete") : t("common.ok")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
